
<section id="cartOverView" style="padding-top:40px;margin-bottom: 80px;" >
    <div class="container">
        <div class="my-container">
            <ng-template #customLoadingTemplate>
                <div class="custom-class">
                </div>
            </ng-template>
         
           <ngx-loading [show]="loading" [config]="{ primaryColour:'#0c3131' ,secondaryColour: '#0c3131',tertiaryColour:'#0c3131',backdropBackgroundColour:'rgba(57, 168, 208, 0.3)', backdropBorderRadius: '3px' ,fullScreenBackdrop:true }" [template]="customLoadingTemplate"></ngx-loading>
       
          </div>
        <table class="orderTable">
            <thead>
                <tr>
                    <th class="col-sm-1">    
                        code<br>
                        <input class="form-control" type="text" style="height: 33px;margin-bottom: 5px;" (keyup)="filter($event.target.value,0)">
                    </th>
                    <th class="col-sm-2">
                        CreationTime<br>
                        <input class="form-control" type="date" style="height: 33px;margin-bottom: 5px;" (keyup)="filter($event.target.value,1)">
                    </th>
                    <th class="col-sm-2">
                        Net Price<br>
                        <input class="form-control" type="text" style="height: 33px;margin-bottom: 5px;" (keyup)="filter($event.target.value,3)">
                    </th>
                    <th class="col-sm-2" *ngIf = "profileType == 46 || profileType == 29 ">
                        Profile Name<br>
                        <input class="form-control" type="text" style="height: 33px;margin-bottom: 5px;" (keyup)="filter($event.target.value,3)">
                    </th>
                    <th class="col-sm-2">
                        SaleStatus<br>
                        <select class="form-control" style="height: 33px;margin-bottom: 5px;" (change)="filter($event.target.value,4)">
                            <option></option>
                            <option [value]="1" >New</option>
                            <option [value]="5">Recieved</option>
                            <option [value]="6">Under Prepare</option>
                            <option [value]="7">Prepared</option>
                            <option [value]="8">Delieverd</option>
                            <option [value]="9">Cashed</option>
                            <option  [value]="2">Canceled</option>
                        </select>
                    </th>
                    <th class="col-sm-2">...</th>
                </tr>
            </thead>
            <tbody *ngIf="getMyOrders">
                <tr *ngFor="let order of getMyOrders;let i = index" [ngClass]="i % 2 == 0 ? 'evenRow' : 'oddRow' ">
                    <td class="col-sm-1"> {{order.Id}}</td>
                    <td class="col-sm-3 "> {{order.CreationTime}}</td>
                    <td class="col-sm-2 "> {{order.Total}}</td>
                    <td class="col-sm-2 " *ngIf = "profileType == 46 || profileType == 29 "> {{order.ProfileName}}</td>
                    <td class="col-sm-2 "> 
                        <select [disabled] ="(order.SaleStatus  == 2  || order.SaleStatus ==9) ? true :  false "  class="form-control" [(value)]="order.SaleStatus"  [ngModel]="order.SaleStatus" (ngModelChange)="orderStatusUpdate($event,order.Id)">
                            <option [value]="1" [disabled]="profileType == 46 || profileType == 29 ">New</option>
                            <option [value]="2" [disabled]>Canceled</option>
                            <!-- Chef = 46, -->
                            <option [value]="5" [disabled]="profileType != 29">Recieved</option>
                            <option [value]="6" [disabled]="profileType != 46">Under Prepare</option>
                            <option [value]="7" [disabled]="profileType != 46">Prepared</option>
                            <!--  Cashier = 29 -->
                            <option [value]="8" [disabled]="profileType != 29">Delieverd</option>
                            <option [value]="9" [disabled]="profileType != 29">Cashed</option>
                        </select>
                    </td>
                    <td class="col-sm-2 "> 
                        <span class="btn" style="background-color: #C59D5F;border-color: #C59D5F;color: #fff; margin-right: 10px;" (click)="getOrderId(order.Id,order.SaleStatus,order.Total)"><i class="fas fa-plus-circle"></i></span>
                        <span class="btn" style="background-color:#C59D5F;border-color:#C59D5F;color: #fff;"  [class.disabledCancel] ="(order.SaleStatus != 1 || profileType == 29 || profileType == 46)? true : false "  (click)="CancelOrder(order.Id,2)"><i class="fas fa-ban"></i></span>
                    </td>
                </tr>
            </tbody>
        </table>
        <nav aria-label="Page navigation example " *ngIf="pagination && pagination.length > 1">
            <ul class="pagination" *ngIf="getMyOrders.length > 10">
                <li class="page-item" [class.disablepaginagtion]="disablePrevious ==true"><a  class="page-link" (click)="previouspagination()" >Previous</a></li>
                <li class="page-item" *ngFor="let image of pagination;let i = index"><a [class.activePagination]="currentPage == i+1"  *ngIf=" i+1 < 3 " class="page-link"  (click)="paginationChange(i+1)" >{{i+1}}</a></li>
                <li class="page-item" ><a  class="page-link"   >...</a></li>
              <li class="page-item" *ngFor="let image of pagination;let i = index"><a *ngIf=" i+1 > pagination.length-2 " class="page-link"  (click)="paginationChange(i+1)" >{{i+1}}</a></li>
              <li class="page-item" [class.disablepaginagtion]="disableNext ==true"><a class="page-link" (click)="nextpagination()">Next</a></li>
            </ul>
            <ul class="pagination" *ngIf="getMyOrders.length < 10">
              <li class="page-item" [class.disablepaginagtion]="disablePrevious ==true"><a class="page-link" (click)="previouspagination()" >Previous</a></li>
              <li class="page-item" *ngFor="let image of pagination;let i = index"><a [class.activePagination]="currentPage == i+1"  class="page-link"  (click)="paginationChange(i+1)" >{{i+1}}</a></li>
           <li class="page-item" [class.disablepaginagtion]="disableNext ==true"><a class="page-link" (click)="nextpagination()">Next</a></li>
          </ul>
        </nav>
    </div>
    
</section>